import getActionSource from '../utils/getActionSource';
import { ActionSource } from 'owa-mail-store';
import { lazyAddMailboxToSafeSenders } from 'owa-mail-triage-action';
import Message from 'owa-service/lib/contract/Message';
import { SurfaceActionItem } from 'owa-surface-actions';
import * as React from 'react';

export default function onAddToSafeSenders(message: Message, actionSource: ActionSource) {
    return (event: React.MouseEvent<HTMLElement>, item?: SurfaceActionItem) => {
        event.stopPropagation();

        lazyAddMailboxToSafeSenders.import().then(addMailboxToSafeSenders => {
            addMailboxToSafeSenders(
                message.Sender.Mailbox,
                message.ItemId.Id,
                getActionSource(item, actionSource)
            );
        });
    };
}
